import { numberify } from "../numberify";

const METRICS_DICTIONARY = [
    ["jsHeapSizeLimit", "js_heap_size_limit"],
    ["totalJSHeapSize", "total_js_heap_size"],
    ["usedJSHeapSize", "used_js_heap_size"],
];

interface MemoryRepresenation {
    js_heap_size_limit?: number;
    total_js_heap_size?: number;
    used_js_heap_size?: number;
}

export function memory(): MemoryRepresenation {
    const { memory } = window.performance || {};
    if (!memory) {
        return {};
    }

    return Object.assign(
        {},
        ...METRICS_DICTIONARY.map(([metric, key]) => ({
            [key]: numberify(memory[metric]),
        })),
    );
}
